import styled from 'styled-components';

import { theme } from '@/theme';

import type { InputColorVariant, RadioProps } from './Radio';

export const getInputBackgroundColor = (
  variant: RadioProps['colorVariant'],
) => {
  switch (variant) {
    case 'inherit': {
      return 'inherit';
    }
    case 'white': {
      return theme.colors.white;
    }
  }
};

export const Wrapper = styled.label<{ disabled: boolean }>`
  display: inline-flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  font-size: ${({ theme }) => theme.fontSizes.p2};
  margin: ${({ theme }) => theme.spacing(1, 0)};
`;

export const InputCheckbox = styled.input<{
  colorVariant: InputColorVariant;
  disabled: boolean;
}>`
  flex-shrink: 0;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  appearance: none;
  margin: 0;
  position: relative;
  color: ${({ theme }) => theme.colors.primaryAdd6};
  background-color: ${({ colorVariant, disabled, theme }) =>
    disabled
      ? theme.colors.disableGrey
      : getInputBackgroundColor(colorVariant)};
  width: 20px;
  height: 20px;
  box-shadow: inset 0 0 0 1px currentColor;
  border-radius: 50%;

  &:before {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: 50%;
    color: ${({ disabled, theme }) =>
      disabled
        ? theme.colors.primaryDisabled
        : theme.components.radio.markColor};
    box-shadow: inset 0 0 0 5px currentColor;
    transform: scale(0);
    transition: 0.2s transform ease-in-out;
  }

  &:checked {
    &:before {
      transform: scale(1);
    }
  }

  &:focus {
    outline: 1px solid transparent;
  }
`;
